var variantPrices = [];
// Money Format
var Shopify = Shopify || {};

Shopify.money_format = window.cartStrings.money_format || "{{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};



// Featured Collection with tabbing Functionality.
const FeaturedCollectionTabbings = document.querySelectorAll('.feaured-collection-with-tabbings');
if(FeaturedCollectionTabbings.length > 0){
  FeaturedCollectionTabbings.forEach(featured_collection=>{
    const AllTabs = featured_collection.querySelectorAll('.js_featured_collection_tab_heaidng');
    if(AllTabs.length > 0){
      AllTabs.forEach((tab, index)=>{
        tab.addEventListener('click', ()=>{
          HandleTabContent(tab, featured_collection, index);
        })
      })
    }
  })
}

const FeaturedCollectionTagsEle = document.querySelectorAll('.js_featured_collection_tabs_products_tags');
if(FeaturedCollectionTagsEle.length > 0){
  FeaturedCollectionTagsEle.forEach(ele=>{
    const AllTagsEle = ele.querySelectorAll('.js_featured_tab_product_tag');
    if(AllTagsEle.length > 0){
      AllTagsEle.forEach(tag_ele=>{
        tag_ele.addEventListener('click',()=>{
          AllTagsEle.forEach(_tag_ele=>{
            if(_tag_ele != tag_ele) _tag_ele.classList.remove('is--active');
          });
          if(tag_ele.classList.contains('is--active')){
            tag_ele.classList.remove('is--active');
          }else{
            tag_ele.classList.add('is--active');
          }
          HandleTagContent(tag_ele);
        })
      })
    }
  })  
}

function HandleTagContent(currentTarget){
  const dataTagAttr = currentTarget.getAttribute('data-tag');
  const ParentEle = currentTarget.closest('.js_featured_collection_tab_content');
  const allProducts = ParentEle.querySelectorAll('.grid__item');
  if(allProducts.length > 0){
    if(currentTarget.classList.contains('is--active')){      
      allProducts.forEach(product=>{
        product.classList.add('hidden');
        const productTags = product.getAttribute('data-product-tags');
        const tags = productTags.split(',');
        Array.from(tags).filter(tag=>{
          if(tag == dataTagAttr){
            if(product.classList.contains('hidden')) product.classList.remove('hidden');
          }
        })
      })
    } else{
      allProducts.forEach(product=>{
        product.classList.remove('hidden');
      })
    }
  }
}

function HandleTabContent(currentTarget, ParentElement, index){
  const allTabs = ParentElement.querySelectorAll('.js_featured_collection_tab_heaidng');
  if(allTabs.length > 0){
    allTabs.forEach(tab=>{
      if(tab.classList.contains('is--selected')) tab.classList.remove('is--selected');
    });
  }

  const tabContents = ParentElement.querySelectorAll('.js_featured_collection_tab_content');
  if(tabContents.length > 0){
    tabContents.forEach(tabContent=>{
      if(tabContent.classList.contains('is--selected')) tabContent.classList.remove('is--selected');
    })
  }
  if(ParentElement.querySelector(`#tab_content_${index}`)){
    ParentElement.querySelector(`#tab_content_${index}`).classList.add('is--selected');
  }
  currentTarget.classList.add('is--selected');
  window.initOrDestroyTabbingSlider();
}

// Update color swatch variant ID
window.updateColorSwatches = function(){
  const AllFieldset = document.querySelectorAll('variant-selects-swatches');
  if(AllFieldset.length > 0){
    AllFieldset.forEach(fieldset=>{
      const AllInputs = fieldset.querySelectorAll('label');
      if(AllInputs.length > 0){
        AllInputs.forEach(input=>{
          input.addEventListener('click', function(event){
            updateColorSwatchVariant(input, event);
          })
        })
      }
      const AllSelectTags = fieldset.querySelectorAll('select');
      if(AllSelectTags.length > 0){
        AllSelectTags.forEach(select=>{
          select.addEventListener('change', function(event){
            updateColorSwatchVariant(select, event);
          })
        })
      }
    })
  }
}
window.updateColorSwatches();

function updateColorSwatchVariant(currentTarget, event){
  if(event.target.tagName == 'LABEL'){
    const closestVariantSelectsSwatches = currentTarget.closest('variant-selects-swatches');
    const innerFieldset = closestVariantSelectsSwatches.querySelectorAll('fieldset');
    const label_for = currentTarget.getAttribute('for');
    const closestFieldset = currentTarget.closest('fieldset');
    var closestContainer = '';
    var closestMainContainer = '';
    if(currentTarget.closest('.quick-buy-drawer__info')){
      closestContainer = currentTarget.closest('.quick-buy-drawer__info');
      closestMainContainer = currentTarget.closest('.js-quick-add-content');
    }else if(currentTarget.closest('.product-card-wrapper')){
      closestContainer = currentTarget.closest('.product-card-wrapper');
    }
    const relatedInput = closestFieldset.querySelector(`input[type="radio"]#${label_for}`);
    const AllInputField = closestFieldset.querySelectorAll('input[type="radio"]');
    if(AllInputField.length > 0){
      AllInputField.forEach(_input=>{
        _input.checked = false;
        _input.removeAttribute('checked');
      });
    }
    relatedInput.checked = true;
    relatedInput.setAttribute('checked', '');
  
    if(closestContainer){
      var currentImageWrapper = '';
      if(currentTarget.closest('.quick-buy-drawer__info')){
        currentImageWrapper = closestMainContainer?.querySelector('variant-media');
      } else{
        currentImageWrapper = closestContainer?.querySelector('.card__media');
      }
      if(currentImageWrapper){
        const imgTag = currentImageWrapper.querySelector('img');
        if(imgTag){
          const selected_variant_preview_srcset_image = relatedInput.getAttribute('data-preview-image');
          if(selected_variant_preview_srcset_image){
            imgTag.setAttribute('srcset', selected_variant_preview_srcset_image);
          }
        }
      }
    }
    getAllCheckedInputs(closestContainer, event);
  }
  else{
    if(event.target.tagName == 'SELECT'){
      const closestFieldset = event.target.closest('.product-card-wrapper');
      if(closestFieldset) getAllCheckedInputs(closestFieldset, event);
    }
  }
}

function getAllCheckedInputs(closestContainer, event){
  const AllProductInputForm = closestContainer.querySelectorAll('.product-form__input');
  if(AllProductInputForm.length > 0){
    var selectedValue = '';
    var selected_variant_id = '';
    var varaintTitle = [];
    AllProductInputForm.forEach((variant_selector, index)=>{
      if(variant_selector.querySelector('select')){
        var currentValue = '';
        if(index == 0 && variant_selector.querySelector('input[type="radio"][checked]')){
          currentValue = variant_selector.querySelector('input[type="radio"][checked]') ? variant_selector.querySelector('input[type="radio"][checked]').value : '';
          varaintTitle.push(currentValue);
        }else if(index == 0 && variant_selector.querySelector('select')){
          currentValue = variant_selector.querySelector('select') ? variant_selector.querySelector('select').value : '';
          varaintTitle.push(currentValue);
        } else{
          currentValue = variant_selector.querySelector('select') ? variant_selector.querySelector('select').value : '';
          varaintTitle.push(currentValue);          
        }
        if(variant_selector.querySelector('.cs_variant_value')) variant_selector.querySelector('.cs_variant_value').innerText = currentValue;
      }else{
        const currentValue = variant_selector.querySelector('input[type="radio"][checked]');
        if(currentValue){          
          varaintTitle.push(currentValue.value);
          if(variant_selector.querySelector('.cs_variant_value')) variant_selector.querySelector('.cs_variant_value').innerText = currentValue.value;
        }
      }
    })
    selectedValue = Array.from(varaintTitle).reduce((acc, curr) => acc + ' / ' + curr);
    // console.log('selectedValue: ', selectedValue);
    const allVariantJson = closestContainer.querySelector('.all_variant_json');
    if(allVariantJson){
      const allVariant = JSON.parse(allVariantJson.textContent);
      const selectedVariant = allVariant.find(variant=> variant.title == selectedValue);
      if(selectedVariant){
        selected_variant_id = selectedVariant.id;
      }
    }
    const product_form = closestContainer.querySelector('product-form');
    if(product_form){
      const form = product_form.querySelector('form');
      const variantID = form.querySelector('input[name="id"]');
      if(variantID){
        variantID.setAttribute('value', selected_variant_id);
      }
    } 
  }
}

window.defaultColorSwatchSelected = function(opener, quickAddContainer){
  const closestWrapperContainer = opener.closest('.product-card-wrapper');
  if(closestWrapperContainer){
    const VariantSelectors = closestWrapperContainer.querySelectorAll('variant-selects-swatches');
    if(VariantSelectors.length > 0){
      VariantSelectors.forEach(variantSelector=>{
        const selectedInputSwtachs = variantSelector.querySelectorAll('input[type="radio"]');
        const selectedSwatch = Array.from(selectedInputSwtachs).find(input=> input.hasAttribute('checked'));
        const selectedSwatchId = selectedSwatch.getAttribute('data-variant-id');
        const quickPopUpvariant = quickAddContainer.querySelector(`input[type="radio"][data-variant-id="${selectedSwatchId}"]`);
        if(quickPopUpvariant){
          const quickPopUpvariantId = quickPopUpvariant.getAttribute('id');
          const selectedInputrelatedLabel = quickAddContainer.querySelector(`label[for="${quickPopUpvariantId}"]`);          
          if(selectedInputrelatedLabel){
            selectedInputrelatedLabel.click();
          }
        }
      })
    }
  }
}


// Show More / Less Functionality in filter on collection page
window.showMoreLessFilter = function() {
  const allFilterLabels = document.querySelectorAll('facet-filters-form [data-filter-label]');
  
  if (allFilterLabels.length === 0) return;

  allFilterLabels.forEach(filterLabel => {
    const filterLabelText = filterLabel.getAttribute('data-filter-label');
    const closestSubMenu = filterLabel.closest('details');
    const showMoreLessBtn = closestSubMenu.querySelector('.js-show-more-less-button');
    const maxHeight = filterLabelText === 'farbe' ? 64 : 134;

    if (filterLabel.offsetHeight > maxHeight && showMoreLessBtn) {
      showMoreLessBtn.classList.remove('hidden');
    }

    filterLabel.style.cssText = `max-height: ${maxHeight}px; overflow-y: hidden;`;
  });
}

window.handleShowMoreLessButton = function() {
  const allShowMoreLessButtons = document.querySelectorAll('.js-show-more-less-button');

  if (allShowMoreLessButtons.length === 0) return;

  allShowMoreLessButtons.forEach(button => {
    const innerSpan = button.querySelector('.js-show-more-less-span');
    
    // Remove existing click event listener if any
    const newInnerSpan = innerSpan.cloneNode(true);
    innerSpan.parentNode.replaceChild(newInnerSpan, innerSpan);

    newInnerSpan.addEventListener('click', () => {
      // button.classList.contains('is--active') ? button.classList.remove('is--active') : button.classList.add('is--active');

      if(button.classList.contains('is--active')){
        button.classList.remove('is--active');
        newInnerSpan.innerText = `${window.facets.showMoreBtnText}`;
      }else{
        button.classList.add('is--active');
        newInnerSpan.innerText = `${window.facets.showLessBtnText}`;
      }
      const closestDetails = newInnerSpan.closest('details');
      const mobileFacetsSubmenu = closestDetails.querySelector('.mobile-facets__submenu');
      const mobileFacetsSubmenuInnerUL = closestDetails.querySelector('.mobile-facets__submenu [data-filter-label]');

      if (mobileFacetsSubmenu) {
        const maxHeight = mobileFacetsSubmenu.getAttribute('data-max-height');

        if (maxHeight) {
          mobileFacetsSubmenuInnerUL.style.cssText = button.classList.contains('is--active') 
            ? 'max-height: initial; overflow-y: hidden;' 
            : `max-height: ${maxHeight}px; overflow-y: hidden;`;
        }
      }
    });
  });
}


window.variantAddedQuickModel = function(response, quickAddModal){
  // console.log('response: ', response);
  // console.log('quickAddModal: ', quickAddModal);
  const variant_title = response.variant_title;
  const product_title = response.product_title;
  const varaint_price = response.presentment_price;
  const image_url = response.image;
  
  const quickModelVariantAddedEle = quickAddModal.querySelector('#quick-model-after-variant-added');
  if(quickModelVariantAddedEle){
    const quickModelVariantAddedContent = quickAddModal.querySelector('.quick-model-after-variant-added-content');
    if(quickModelVariantAddedEle){
      quickAddModal.setAttribute('open','');
      document.body.classList.add('js-overflow-hidden');
      if(quickAddModal.querySelector('.quick-add-modal__toggle')){
        quickAddModal.querySelector('.quick-add-modal__toggle').remove();
      }
      const cs_quick_buy_drawer_variant = quickModelVariantAddedContent.querySelector('.cs_quick_buy_drawer_variant');
      if(cs_quick_buy_drawer_variant){
        const image = cs_quick_buy_drawer_variant.querySelector('.cs_quick_buy_drawer_variant_image');
        if(image){
          image.src = image_url;
        }
        const variant_title_with_price = cs_quick_buy_drawer_variant.querySelector('.cs_variant_title_with_price');
        if(variant_title_with_price){
          const product_title_ele = variant_title_with_price.querySelector('.cs_product_title .cs_title');
          const cs_variant_price = variant_title_with_price.querySelector('.cs_product_title .cs_variant_price');
          const cs_variant_title = variant_title_with_price.querySelector('.cs_variant_title');
          if(product_title_ele){
            product_title_ele.innerText = product_title;
          }
          if(cs_variant_price){
            const currency = cs_variant_price.getAttribute('data-currency');
            cs_variant_price.innerText = currency + ' ' + varaint_price;
          }
          if(cs_variant_title){
            cs_variant_title.innerText = variant_title;
          }
        }
      }
      if(quickModelVariantAddedEle.classList.contains('hidden')){
        quickModelVariantAddedEle.classList.remove('hidden');
      }
      const cs_cart_button = quickModelVariantAddedContent.querySelector('.cartButton');
      if(cs_cart_button){
        cs_cart_button.addEventListener('click', ()=> {
          quickAddModal.removeAttribute('open');
          document.body.classList.add('js-overflow-hidden');
          document.querySelector('#cart-icon-bubble').click();
        });
      }
    }
  }

}


// Show more / less functionality in product media lists
const allProductMediaLists = document.querySelectorAll('.product_media_lists_show_more_buttons_container');

if (allProductMediaLists.length > 0) {
  allProductMediaLists.forEach(productMediaList => {
    const button = productMediaList.querySelector('.span_with_icon_wrapper');
    button.addEventListener('click', toggleProductMediaLists.bind(this));
  });
}

function toggleProductMediaLists(evt) {
  const currentTarget = evt.target;
  const productMediaListsContainer = currentTarget.closest('.product_media_lists_container');

  if (!productMediaListsContainer) return;

  const productMediaList = productMediaListsContainer.querySelector('.product__media-list');
  if (!productMediaList) return;

  const productMediaItems = productMediaList.querySelectorAll('.product__media-item');
  productMediaItems.forEach(productMediaItem => {
    const isAlwaysActive = productMediaItem.classList.contains('always-active');
    const isMatchedListItem = productMediaItem.classList.contains('matched_list_item');

    if (isAlwaysActive && isMatchedListItem) {
      productMediaItem.classList.toggle('js-is-hidden');
    } else if (!isAlwaysActive) {
      productMediaItem.classList.toggle('js-is-hidden');
    }
  });

  const innerSpan = currentTarget.querySelector('span');
  currentTarget.classList.toggle('is--active');
  innerSpan.innerText = currentTarget.classList.contains('is--active') 
    ? window.productMediaLists.showLessBtnText 
    : window.productMediaLists.showMoreBtnText;
}


let _swiper = null;

function initSwiperForMobile() {
  if (window.innerWidth <= 768 && !_swiper) {
    _swiper = new Swiper(".category-grid__slidertom", {
      slidesPerView: 2.5,
      spaceBetween: 10,
      loop: false,
    });
  } else if (window.innerWidth > 768 && _swiper) {
    _swiper.destroy(true, true);
    _swiper = null;
  }
}

window.addEventListener("load", initSwiperForMobile);
window.addEventListener("resize", initSwiperForMobile);


document.addEventListener('DOMContentLoaded', function() {
  const faqQuestions = document.querySelectorAll('.faq-question');
  
  faqQuestions.forEach(question => {
    question.addEventListener('click', () => {
      const answer = question.nextElementSibling;
      const icon = question.querySelector('.icon');
      
      // Toggle answer visibility
      if (answer.style.display === 'block') {
        answer.style.display = 'none';
        if (icon.textContent === '−') {
          icon.textContent = '+';
        } else if (icon.textContent === '↑') {
          icon.textContent = '↓';
        }
      } else {
        answer.style.display = 'block';
        if (icon.textContent === '+') {
          icon.textContent = '−';
        } else if (icon.textContent === '↓') {
          icon.textContent = '↑';
        }
      }
    });
  });
}); 

// custom filter banner 
window.handleCustomFilterBanner = function(){
  if(document.querySelectorAll('.products-type').length > 0){
    document.querySelectorAll('.products-type').forEach(productTypeEl => {
        document.querySelectorAll('.category-item.active-filter').forEach(item => {
          item.classList.remove('active-filter');
        });
      productTypeEl.addEventListener('click', (e) => {
        document.querySelectorAll('.category-item.active-filter').forEach(item => {
          item.classList.remove('active-filter');
        });
        const categoryItem = productTypeEl.closest('.category-item');
        if (categoryItem) {
          categoryItem.classList.add('active-filter');
        }
        const current_product_type = e.target.closest('.products-type').dataset.handle.trim().toLowerCase();
        document.querySelectorAll('.mobile-facets__checkbox').forEach(input => {
          if (input.checked) {
            input.click(); 
          }
        });
        document.querySelectorAll('.mobile-facets__checkbox').forEach(input => {
          const inputValue = input.value.trim().toLowerCase();
          if (inputValue === current_product_type && !input.checked) {
            input.click();
          }
        });
      });
    });
  }
}
window.handleCustomFilterBanner();



/// product form progressbar
window.updateCustomQuantity = function () {
  function handleQuantity(currentTarget) {
    const quantity = currentTarget.value;
    const currentOptionPrice = currentTarget.getAttribute('option-price');
    const closestForm = currentTarget.closest('.product__info-wrapper');
    const closestBuyButton = closestForm?.querySelector('[data-button-price]');
    const quantityInput = closestForm?.querySelector("[name='quantity']");

    if (quantityInput) {
      quantityInput.value = quantity;
    }
    if (closestBuyButton) {
      closestBuyButton.innerText = currentOptionPrice + " " + Shopify.currency.active;
    }
  }
  const customQuantityRadios = document.querySelectorAll(".custom-quantity");
  customQuantityRadios.forEach((radio) => {
    radio.addEventListener("click", () => {
      handleQuantity(radio);
    });
  });
  const selectedQuantity = document.querySelector(".custom-quantity:checked");
  if (selectedQuantity) {
    handleQuantity(selectedQuantity);
  }
};
document.addEventListener("DOMContentLoaded", function () {
  window.updateCustomQuantity();
});
// custom-progressbar 
document.addEventListener('DOMContentLoaded', function() {
  const radios = document.querySelectorAll('.custom-quantity');
  const progressBar = document.getElementById('customProgressBar');
  const total = radios.length;
  function updateProgressBar() {
    let checkedIndex = 0;
    radios.forEach((radio, idx) => {
      if (radio.checked) checkedIndex = idx;
    });
    const percent = ((checkedIndex + 1) / total) * 100;
    if(progressBar) progressBar.style.width = percent + '%';
  }
  radios.forEach(radio => {
    radio.addEventListener('change', updateProgressBar);
    radio.addEventListener('click', updateProgressBar);
  });
  updateProgressBar();
});

////////////////
let flickityInstance = null;
let flickityInstanceForTabbings = null;

function initFlickitySlider(elem, options) {
  if (!elem.classList.contains('flickity-enabled')) {
    return new Flickity(elem, options);
  }
  return null;
}

function destroyFlickitySlider(instance) {
  if (instance) {
    instance.destroy();
    return null;
  }
  return instance;
}

// Custom image banner slider Javascript
function initOrDestroyBannerSlider() {
  const bannerSliders = document.querySelectorAll('.banner__media-slider');
  bannerSliders.forEach((elem) => {
    if (window.innerWidth <= 749) {
      flickityInstance = initFlickitySlider(elem, {
        cellAlign: 'center',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        autoPlay: true
      });
    } else {
      flickityInstance = destroyFlickitySlider(flickityInstance);
    }
  });
}

// Featured Collection with Tabbings slider Javascript
let flickityTabbingInstances = [];
window.initOrDestroyTabbingSlider = function initOrDestroyTabbingSlider() {
  // Destroy all previous instances
  if (flickityTabbingInstances && flickityTabbingInstances.length > 0) {
    flickityTabbingInstances.forEach(instance => {
      if (instance) instance.destroy();
    });
    flickityTabbingInstances = [];
  }

  // Re-init all sliders
  const tabSliders = document.querySelectorAll('.js-featured-collection-tabs-slider');
  tabSliders.forEach((elem) => {
    if (!elem.classList.contains('flickity-enabled')) {
      const instance = new Flickity(elem, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        autoPlay: false
      });
      flickityTabbingInstances.push(instance);
    }
  });
}

initOrDestroyBannerSlider();
window.initOrDestroyTabbingSlider();

// Resize event listener
window.addEventListener('resize', () => {
  clearTimeout(window._bannerSliderTimeout);
  window._bannerSliderTimeout = setTimeout(initOrDestroyBannerSlider, 150);
});


const AllNavLists = document.querySelectorAll('nav.header__inline-menu');
if(AllNavLists.length > 0){
  AllNavLists.forEach(nav=>{
    const AllLi = nav.querySelectorAll('li');
    if(AllLi.length > 0){
      AllLi.forEach(list=>{
        const innerA = list.querySelector('a');
        innerA.addEventListener('mouseenter', ()=>{
          if(innerA) innerA.classList.add('header__active-menu-item');
        });
        innerA.addEventListener('mouseleave', ()=>{
          if(innerA) innerA.classList.remove('header__active-menu-item');
        });
      })
    }
  })
}


document.addEventListener('DOMContentLoaded', function () {
  // ------- Collection page banner slider --------
  const categoryGrid = document.querySelector('.category-grid.category-grid__slidertom');
   if (!categoryGrid) return;
  const categoryItems = Array.from(categoryGrid.querySelectorAll('.category-item'));

  categoryGrid.innerHTML = '';

  for (let i = 0; i < categoryItems.length; i += 2) {
    const cell = document.createElement('div');
    cell.classList.add('flickity-cell');

    cell.appendChild(categoryItems[i]);
    if (categoryItems[i + 1]) cell.appendChild(categoryItems[i + 1]);

    categoryGrid.appendChild(cell);
  }

  new Flickity(categoryGrid, {
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    prevNextButtons: false,
    draggable: '>1',
    groupCells: false,
  });
});



window.initFlickityonPDPSwatches = function () {
  const productColorVariant = document.querySelectorAll(
    '.product .pro_variant_pick .product-form__input--color .product-form__input--color--flickity--slider'
  );

  if (productColorVariant.length > 0) {
    productColorVariant.forEach((variant) => {
      const variantLabel = variant.querySelectorAll('label');

      if (variantLabel.length > 4) {
        const flickitySlider = new Flickity(variant, {
          cellAlign: 'left',
          draggable: true,
          contain: true,
          wrapAround: false,
          pageDots: false,
          prevNextButtons: false // using custom buttons
        });

        const container = variant.closest('.product-form__input--color');
        const prevButton = container?.querySelector('.slider-button--prev');
        const nextButton = container?.querySelector('.slider-button--next');

        if (prevButton && nextButton) {
          prevButton.addEventListener('click', () => {
            flickitySlider.previous();
          });

          nextButton.addEventListener('click', () => {
            flickitySlider.next();
          });

          function updateArrowState() {
            prevButton.disabled = flickitySlider.selectedIndex === 0;
            nextButton.disabled = flickitySlider.selectedIndex === flickitySlider.slides.length - 1;
          }

          flickitySlider.on('change', updateArrowState);
          updateArrowState();
        }

        setTimeout(() => {
          variant.style.opacity = 1;
        }, 500);
      } else {
        variant.style.opacity = 1;
      }
    });
  }
};


window.initFlickityonPDPSwatches();

const bundle_product_list_flickity = document.querySelectorAll('.slider_wrap_main');
if(bundle_product_list_flickity.length > 0){
  bundle_product_list_flickity.forEach(slider=>{
    // Set height to 0 before initializing Flickity
    // slider.style.opacity = 0;
    
    const flickitySlider = new Flickity(slider, {
      contain: true,
      groupCells: 1,
      pageDots: true,
      prevNextButtons: false,
      autoPlay: false,
      on: {
        ready: function() {
          // Reset height after Flickity is initialized
          slider.style.opacity = 1;
        }
      }
    });
  });
}

// Bundle Products Add to Cart functionality.
window.handleBundleProducts = function(){
  const allBundleContainers = document.querySelectorAll('.js-bundle-container');
  if(allBundleContainers.length > 0){
    allBundleContainers.forEach(bundle_container=>{
      const addToCartButton = bundle_container.querySelector('.bundle-add-to-cart');
      if(addToCartButton){
        addToCartButton.addEventListener('click', ()=>{
          addBundleProductToCart(addToCartButton, bundle_container);
        });
      }
      const bundle_products = bundle_container.querySelectorAll('.bundle-product');
      if(bundle_products.length > 0){
        bundle_products.forEach((bundle_product, index)=>{
          const all_variant_selectors = bundle_product.querySelectorAll('.variant-select');
          if(all_variant_selectors.length > 0){
            all_variant_selectors.forEach((variant_selector)=>{
              variant_selector.addEventListener('change', ()=>{
                updateBundleVariant(variant_selector, bundle_product);
              });
            });
          }
        });
      }
    });
  }
}

function updateBundleVariant(variant_selector, bundle_product_container){
  var selectedValue = '';
  var selected_variant_id = '';
  var varaintTitle = [];
  const bundleProductImage = bundle_product_container.querySelector('.bundle-product-image');
  if(bundleProductImage){
    const innerImage = bundleProductImage.querySelector('img');
    if(innerImage && variant_selector.options[variant_selector.selectedIndex].hasAttribute('data-variant-image')){
      innerImage.src = variant_selector.options[variant_selector.selectedIndex]?.getAttribute('data-variant-image');
    }
  }
  // const current_variant_selector_value = variant_selector.value;
  const AllSelectedVariantValue = bundle_product_container.querySelectorAll('.variant-select');
  if(AllSelectedVariantValue.length > 0){
    AllSelectedVariantValue.forEach(selected_variant_value=>{
      varaintTitle.push(selected_variant_value.value);
    });
  }
  // selected_values.push(current_variant_selector_value);
  selectedValue = Array.from(varaintTitle).reduce((acc, curr) => acc + ' / ' + curr);

  const currentVariantJson = bundle_product_container.querySelector('.product_variants_json');
  // console.log(currentVariantJson);
  const bundleProductPrice = bundle_product_container.querySelector('.bundle-product-price');
  if(currentVariantJson){
    const allVariant = JSON.parse(currentVariantJson.textContent);
    const selectedVariant = allVariant.find(variant=> variant.title == selectedValue);
    if(selectedVariant){
      selected_variant_id = selectedVariant.id;
      if(bundleProductPrice) bundleProductPrice.setAttribute('value', selectedVariant.price);
    }

    // console.log(Shopify.formatMoney(selectedVariant.price, Shopify.money_format));
  }
  updateAddtoCartButtonState(selected_variant_id, variant_selector, bundle_product_container);
}

function updateAddtoCartButtonState(variant_id, variant_selector, bundle_product_container){
  const closestMainContainer = variant_selector.closest('.js-bundle-container');
  const allVariantSelectors = closestMainContainer.querySelectorAll('.variant-select');
  const addToCartButton = closestMainContainer.querySelector('.bundle-add-to-cart');
  const bundleProductPrice = bundle_product_container.querySelector('.bundle-product-price');
  const bundleProductPriceEle = closestMainContainer.querySelector('.discount-price');
  if (allVariantSelectors.length > 0) {
    const allSelectorsValid = Array.from(allVariantSelectors).every(selector => {
      return selector.value !== '' && selector.value !== null;
    });
    
    if(addToCartButton){
      allSelectorsValid ? addToCartButton.removeAttribute('disabled') : addToCartButton.setAttribute('disabled', true);
    }
    if(allSelectorsValid){
      const bundleProductPrices = closestMainContainer.querySelectorAll('.bundle-product-price');
      if(bundleProductPrices.length > 0){
        const totalPrice = Array.from(bundleProductPrices).reduce((acc, currentValue)=>{
          const currentPrice = Number(currentValue.value);
          return acc + currentPrice;
        }, 0);
        const discount_price = Number(bundleProductPrice?.getAttribute('data-discount-value') / 100.00);
        const minusPrice = discount_price * totalPrice;
        const final_price = totalPrice - minusPrice;
        
        // console.log(Shopify.formatMoney(final_price, Shopify.money_format));
        if(bundleProductPriceEle && final_price) bundleProductPriceEle.innerText = Shopify.formatMoney(final_price, Shopify.money_format);
      }
    }
  }
  if(!variant_id) return;
  const bundleProductIds = bundle_product_container.querySelector('.bundle-product-ids');
  if(bundleProductIds){
    bundleProductIds.value = variant_id;
  }
}

async function addBundleProductToCart(addToCartButton, closestMainContainer){
  // Disable the add to cart button while processing
  addToCartButton.setAttribute('disabled', true);
  addToCartButton.setAttribute('aria-busy', true);
  const itemsArray = [];
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const bundleProductIds = closestMainContainer.querySelectorAll('.bundle-product-ids');
  if(bundleProductIds.length > 0){
    bundleProductIds.forEach(bundleProductId=>{
      itemsArray.push({
        id: bundleProductId.value,
        quantity: 1
      });
    });
  }
  console.log(itemsArray);
  if(itemsArray.length <= 0) return;
  const headers = { method: "POST", headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: itemsArray}) };
  const response = await fetch(`${window.Shopify.routes.root}cart/add.js?sections=${cart.getSectionsToRender().map((section) => section.id).join(",")}&sections_url=${window.location.pathname}`, headers);
  const data = await response.json();
  cart.renderContents(data, false);
  addToCartButton.removeAttribute('disabled');
  addToCartButton.removeAttribute('aria-busy');
  bundleProductIds.value = '';
}

window.handleBundleProducts();

const AllProductMediaSlider = document.querySelectorAll('.product--slider .product__media-list');
if(AllProductMediaSlider.length > 0){
  AllProductMediaSlider.forEach(slider=>{
    const flickitySlider = new Flickity(slider, {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      wrapAround: true,
      prevNextButtons: true,
      draggable: true,
      groupCells: 1,
      selectedAttraction: 0.01,
      friction: 0.15 
    });
  });
}

// Combo Products functionality.
const AllComboProducts = document.querySelectorAll('.js-combo-products-list');
if(AllComboProducts.length > 0){
  AllComboProducts.forEach(combo_products=>{
    const combo_product = combo_products.querySelectorAll('.js-combo-product');
    if(combo_product.length > 0){
      combo_product.forEach(product=>{
        const allColorItems = product.querySelectorAll('.js-color-swatch-item');
        const allSizeItems = product.querySelectorAll('.js-size-btn-item');
        if(allColorItems.length > 0){
          allColorItems.forEach(color_item=>{
            color_item.addEventListener('click', ()=>{
              updateComboProductVariant(color_item, product, true);
            });
          });
        }
        if(allSizeItems.length > 0){
          allSizeItems.forEach(size_item=>{
            size_item.addEventListener('click', ()=>{
             if(!size_item.classList.contains('disabled')) updateComboProductVariant(size_item, product, false);
            });
          });
        }        
      })
    }
    const AddToCartButton = combo_products.querySelector('.js-combo-add-to-cart-btn');
    if(AddToCartButton){
      AddToCartButton.addEventListener('click', ()=>{
        addComboProductToCart(combo_products);
      });
    }
  })
}

function updateComboProductVariant(currentTarget, combo_product_container, has_color_select) {
  const innerImage = combo_product_container.querySelector('.js-combo-product-image');
  const combo_product_id = combo_product_container.querySelector('.combo_product_id');
  const currentVariantLabel = currentTarget.getAttribute('data_variant_value');
  const allColorItems = combo_product_container.querySelectorAll('.js-color-swatch-item');
  const allSizeItems = combo_product_container.querySelectorAll('.js-size-btn-item');
  const current_product_json = combo_product_container.querySelector('.current_product_json');
  
  let current_product = {};
  if (current_product_json) {
    current_product = JSON.parse(current_product_json.textContent);
  }

  // Update image if available
  if (innerImage && currentTarget.hasAttribute('data_variant_image')) {
    innerImage.src = currentTarget.getAttribute('data_variant_image');
  }

  if (has_color_select) {
    handleSizeItems(current_product, currentVariantLabel, allSizeItems, combo_product_container);
  }

  updateSelectedItem(currentTarget, allColorItems, allSizeItems, currentVariantLabel, combo_product_container);
  
  const variantValueArray = Array.from(combo_product_container.querySelectorAll('.product-option .selected'))
    .map(item => item.getAttribute('data_variant_value'));

  const currentVariantName = variantValueArray.join(' / ');
  const variantDetail = current_product.variants.find(variant => variant.title === currentVariantName);
  
  if (variantDetail && variantDetail.available) {
    combo_product_id.setAttribute('value', variantDetail.id);
  }
}

function handleSizeItems(current_product, currentVariantLabel, allSizeItems, combo_product_container) {
  const selectedVariants = current_product.variants.filter(variant => variant.title.includes(currentVariantLabel));
  const unavailableVariants = selectedVariants.filter(variant => !variant.available);

  allSizeItems.forEach(size_item => size_item.classList.remove('disabled'));

  if (unavailableVariants.length > 0) {
    unavailableVariants.forEach(variant => {
      const index = selectedVariants.findIndex(v => v.id === variant.id);
      if (index !== -1 && allSizeItems[index]) {
        allSizeItems[index].classList.add('disabled');
      }
    });
  }

  const currentlySelectedSize = combo_product_container.querySelector('.js-size-btn-item.selected');
  if (currentlySelectedSize && currentlySelectedSize.classList.contains('disabled')) {
    // Only then find and select the first available size
    const firstAvailableSizeItem = Array.from(allSizeItems).find(sizeItem => !sizeItem.classList.contains('disabled'));
    if (firstAvailableSizeItem) {
      allSizeItems.forEach(size_item => size_item.classList.remove('selected'));
      firstAvailableSizeItem.classList.add('selected');
      combo_product_container.querySelector('.js-size-option-value').innerText = firstAvailableSizeItem.getAttribute('data_variant_value');
    }
  }
}

function updateSelectedItem(currentTarget, allColorItems, allSizeItems, currentVariantLabel, combo_product_container) {
  if (currentTarget.classList.contains('js-color-swatch-item')) {
    combo_product_container.querySelector('.js-color-option-value').innerText = currentVariantLabel;
    allColorItems.forEach(color_item => color_item.classList.remove('selected'));
    currentTarget.classList.add('selected');
  } else if (currentTarget.classList.contains('js-size-btn-item')) {
    combo_product_container.querySelector('.js-size-option-value').innerText = currentVariantLabel;
    allSizeItems.forEach(size_item => size_item.classList.remove('selected'));
    currentTarget.classList.add('selected');
  }
}


async function addComboProductToCart(main_container){
  const AddToCartButton = main_container.querySelector('.js-combo-add-to-cart-btn');
  AddToCartButton.setAttribute('disabled', true);
  AddToCartButton.setAttribute('aria-busy', true);
  let itemsArray = [];
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const combo_product_id = main_container.querySelectorAll('.combo_product_id');
  if(combo_product_id.length > 0){
    combo_product_id.forEach(item=>{
      itemsArray.push({
        id: item.value,
        quantity: 1
      });
    });
  }

  if(itemsArray.length <= 0) return;
  const headers = { method: "POST", headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: itemsArray}) };
  const response = await fetch(`${window.Shopify.routes.root}cart/add.js?sections=${cart.getSectionsToRender().map((section) => section.id).join(",")}&sections_url=${window.location.pathname}`, headers);
  const data = await response.json();
  cart.renderContents(data, false);
  AddToCartButton.removeAttribute('disabled');
  AddToCartButton.removeAttribute('aria-busy');  
}


window.productUpdateImage = function(target, currentOption) {
  // console.log(currentOption);
  if(currentOption == 'color' || currentOption == 'colour' || currentOption == 'farbe'){    
    const selectedValue = target.toLowerCase();
    const mediaImages = document.querySelectorAll('.product__media[data-image-alt]');
    const productMediaItems = document.querySelectorAll('.product__media-item');
    const productThumbnailsMediaItems = document.querySelectorAll('.thumbnail-list__item[data-thumbnail-alt-tag]');
    const MAX_VISIBLE_ITEMS = 3;
    productMediaItems.forEach(item => item.classList.add('hidden'));
    productThumbnailsMediaItems.forEach(item => item.classList.add('hidden'));

    mediaImages.forEach(image => {
      const imageAlt = image.getAttribute('data-image-alt').toLowerCase();
      if (imageAlt.includes('color/') || imageAlt.includes('colour/') || imageAlt.includes('farbe/')) {
        const firstAttribute = imageAlt.split('/')[0];
        const targetImageAlt = `${firstAttribute}/${selectedValue}`;
        // console.log(imageAlt, " == ", targetImageAlt) 
        if (imageAlt == targetImageAlt) {
            image.closest('.product__media-item').classList.remove('hidden');
        }
      }
    });
    productThumbnailsMediaItems.forEach(image => {
      const imageAlt = image.getAttribute('data-thumbnail-alt-tag').toLowerCase();
      if (imageAlt.includes('color/') || imageAlt.includes('colour/') || imageAlt.includes('farbe/')) {
        const firstAttribute = imageAlt.split('/')[0];
        const targetImageAlt = `${firstAttribute}/${selectedValue}`;
        if (imageAlt == targetImageAlt) {
            image.classList.remove('hidden');
        }
      }
    });

    const visibleMediaItems = Array.from(productMediaItems).filter(item => !item.classList.contains('hidden'));
    const visibleCount = visibleMediaItems.length;

    visibleMediaItems.forEach((item, index) => {
      if (index > MAX_VISIBLE_ITEMS - 1 && item.classList.contains('template--budnle-product')) {
          item.classList.add('js-is-hidden', 'matched_list_item');
      }
    });

    const mediaListsContainer = document.querySelector('.product_media_lists_container');
    if (mediaListsContainer) {
      const showMoreLessButton = mediaListsContainer.querySelector('.product_media_lists_show_more_buttons_container');
      if (showMoreLessButton) {
          showMoreLessButton.classList.toggle('hidden', visibleCount <= MAX_VISIBLE_ITEMS);
      }
    }
  }
}



// B2B popup js start here 
document.addEventListener("DOMContentLoaded", function () {
    const showMoreBtn = document.querySelector('.js-b2b-show-more-btn');
    const popup = document.querySelector('.customb2b__popup');
    const closeIcon = document.querySelector('.closeicon');
    const Cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    // Function to show popup
    function showPopup() {
      popup.classList.add('b2bpopup-active');
      document.body.classList.add('b2bpopup-active');
    }

    // Function to hide popup
    function hidePopup() {
      popup.classList.remove('b2bpopup-active');
      document.body.classList.remove('b2bpopup-active');
    }

    // Show popup on button click
    if(showMoreBtn){
      showMoreBtn.addEventListener('click', function (e) {
        e.stopPropagation(); // Prevents it from triggering document click
        showPopup();
      });
    }

    // Close on close icon
    if(closeIcon){
      closeIcon.addEventListener('click', function (e) {
        e.stopPropagation();
        hidePopup();
      });
    }

    // Close on outside click
    document.addEventListener('click', function (e) {
      if(popup){
        const isClickInsidePopup = popup.contains(e.target);
        const isClickOnButton = showMoreBtn.contains(e.target);
        const isClickOnCart = Cart.contains(e.target);
  
        if (!isClickInsidePopup && !isClickOnButton  && !isClickOnCart) {
          hidePopup();
        }
      }
    });

     const slider = document.querySelector('.drag-scroll');
      let isDown = false;
      let startX;
      let scrollLeft;

      if(slider){
        slider.addEventListener('mousedown', (e) => {
          isDown = true;
          slider.classList.add('active');
          startX = e.pageX - slider.offsetLeft;
          scrollLeft = slider.scrollLeft;
        });
  
        slider.addEventListener('mouseleave', () => {
          isDown = false;
          slider.classList.remove('active');
        });
  
        slider.addEventListener('mouseup', () => {
          isDown = false;
          slider.classList.remove('active');
        });
  
        slider.addEventListener('mousemove', (e) => {
          if (!isDown) return;
          e.preventDefault();
          const x = e.pageX - slider.offsetLeft;
          const walk = (x - startX) * 1; // scroll speed
          slider.scrollLeft = scrollLeft - walk;
        });
      }
  
  });

  
function handleB2BCustomersPopup() {
  const data = {
    variants: [],
  };
  const popup = document.querySelectorAll('.customb2b__popup');
  if(popup.length > 0){
    popup.forEach(_popup=>{
      const variantInputDetails = _popup.querySelectorAll('.js-variant-input-details');
      if(variantInputDetails.length > 0){
        variantInputDetails.forEach(variantInputDetail=>{
          const inputQuantity = variantInputDetail.querySelector('.b2bquantity');
          if(inputQuantity){
            // Validate input to only allow numbers
            inputQuantity.addEventListener('input', (e)=>{
              // Remove any non-numeric characters except empty string
              const value = e.target.value;
              if(value === '' || /^\d+$/.test(value)) {
                updateQuantity(data, variantInputDetail,variantInputDetails, _popup);
              } else {
                // Reset to previous valid value or 0
                e.target.value = e.target.value.replace(/\D/g, '') || '0';
                updateQuantity(data, variantInputDetail,variantInputDetails, _popup);
              }
            });
            
            // Handle paste events
            inputQuantity.addEventListener('paste', (e)=>{
              setTimeout(() => {
                const value = e.target.value;
                e.target.value = value.replace(/\D/g, '') || '0';
                updateQuantity(data, variantInputDetail,variantInputDetails, _popup);
              }, 0);
            });
          }
        })
      }
    })
  }
  
  window.b2bData = data;
}

handleB2BCustomersPopup();

function updateQuantity(data, variantInputDetail, variantInputDetailsWrapper, mainWrapper){
  let totalQuantity = 0;
  let productVariantDetailJSON = {};
  const footerGroup = mainWrapper.querySelector('.customb2b-footergroup');
  const productVariantsJson = variantInputDetail.querySelector('.product_variants_json');
  
  if(productVariantsJson){
    productVariantDetailJSON = JSON.parse(productVariantsJson.textContent);
  }
  
  const inputQuantity = variantInputDetail.querySelector('.b2bquantity');
  const currentQuantity = inputQuantity ? (parseInt(inputQuantity.value) || 0) : 0;
  
  if(productVariantDetailJSON){
    productVariantDetailJSON.quantity = currentQuantity;
    
    const existingVariantIndex = data.variants.findIndex(variant => variant.variant_id === productVariantDetailJSON.variant_id);
    
    if(currentQuantity > 0) {
      if(existingVariantIndex !== -1) {
        data.variants[existingVariantIndex].quantity = currentQuantity;
      } else {
        data.variants.push(productVariantDetailJSON);
      }
    } else {
      if(existingVariantIndex !== -1) {
        data.variants.splice(existingVariantIndex, 1);
      }
    }
  }
  
  if(variantInputDetailsWrapper.length > 0){
    totalQuantity = Array.from(variantInputDetailsWrapper).reduce((acc, curr)=>{
      const inputQuantity = curr.querySelector('.b2bquantity');
      if(inputQuantity){
        const quantity = parseInt(inputQuantity.value) || 0;
        return acc + quantity;
      }
      return acc;
    }, 0);
  }
  
  // Ensure totalQuantity is never NaN
  totalQuantity = isNaN(totalQuantity) ? 0 : totalQuantity;
  
  if(footerGroup){
    const itemCountWrapper = footerGroup.querySelector('.itemCountWrapper');
    const AddToCartButton = footerGroup.querySelector('.js-customb2b-addtocart-all');
    if(itemCountWrapper){
      const itemCount = itemCountWrapper.querySelector('.itemcount');
      if(itemCount) {
        // Ensure totalQuantity is always a valid number
        const displayQuantity = isNaN(totalQuantity) ? 0 : totalQuantity;
        itemCount.innerText = displayQuantity;
      }
    }
    if(AddToCartButton){
      if(totalQuantity > 0){
        AddToCartButton.removeAttribute('disabled');
      } else {
        AddToCartButton.setAttribute('disabled', true);
      }
      // AddToCartButton.addEventListener('click', ()=>{
      //   addB2BProductToCart(footerGroup, data);
      // });
    }
  }
    
  renderPrice(data, footerGroup);
}

const newPopup = document.querySelector('.customb2b__popup');
if(newPopup){
  const newFooterGroup = newPopup.querySelector('.customb2b-footergroup');
  if(newFooterGroup){
    const newAddToCartButton = newFooterGroup.querySelector('.js-customb2b-addtocart-all');
    if(newAddToCartButton){
      newAddToCartButton.addEventListener('click', ()=>{
        addB2BProductToCart(newFooterGroup, window.b2bData);
      });
    }
  }
}

function renderPrice(data, footerGroup){
  let totalPrice = 0;
  
  totalPrice = data.variants.reduce((sum, variant) => {
    const variantTotal = (variant.price * (variant.quantity || 0));
    return sum + variantTotal;
  }, 0);
    
  if(footerGroup){
    const totalPriceElement = footerGroup.querySelector('.amount');
    if(totalPriceElement) {
      totalPriceElement.textContent = Shopify.formatMoney(totalPrice, Shopify.money_format);
    }
  }
}

function resetPopup(footerGroup){
  const mainWrapper = footerGroup.closest('.customb2b__popup');
  const itemCountWrapper = footerGroup.querySelector('.itemCountWrapper');
  const totalPriceWrapper = footerGroup.querySelector('.amount');
  const AddToCartButton = footerGroup.querySelector('.js-customb2b-addtocart-all');
  if(mainWrapper){
    const variantInputDetails = mainWrapper.querySelectorAll('.js-variant-input-details');
    if(variantInputDetails.length > 0){
      variantInputDetails.forEach(variantInputDetail=>{
        const inputQuantity = variantInputDetail.querySelector('.b2bquantity');
        if(inputQuantity) inputQuantity.value = '0';
      });
    }
    const data = {
      variants: [],
    };
    window.b2bData = {
      variants: [],
    };
    console.log(window.b2bData);
    if(itemCountWrapper){
      const itemCount = itemCountWrapper.querySelector('.itemcount');
      if(itemCount) itemCount.innerText = '0';
    }
    if(AddToCartButton){
      AddToCartButton.setAttribute('disabled', true);
    }
    if(totalPriceWrapper){
      totalPriceWrapper.innerText = Shopify.formatMoney(0, Shopify.money_format);
    }
    mainWrapper.classList.remove('b2bpopup-active');
    document.body.classList.remove('b2bpopup-active');
  }
  
}

async function addB2BProductToCart(footerGroup, data){
  const addToCartButton = footerGroup.querySelector('.js-customb2b-addtocart-all');
  if(addToCartButton){
    addToCartButton.setAttribute('disabled', true);
    addToCartButton.setAttribute('aria-busy', true);
  }
  const items = data.variants.map((p) => ({ id: p.variant_id, quantity: p.quantity }));
  const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  const headers = { method: "POST", headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: items}) };
  const response = await fetch(`${window.Shopify.routes.root}cart/add.js?sections=${cart.getSectionsToRender().map((section) => section.id).join(",")}&sections_url=${window.location.pathname}`, headers);
  const _data = await response.json();
  cart.renderContents(_data, false);
  if(addToCartButton){
    addToCartButton.removeAttribute('disabled');
    addToCartButton.removeAttribute('aria-busy');
  }
  setTimeout(()=> resetPopup(footerGroup), 500);
}

function getCurrentVariants() {
  return window.b2bData ? window.b2bData.variants : [];
}

function getVariantById(variantId) {
  const variants = getCurrentVariants();
  return variants.find(variant => variant.variant_id === variantId);
}

function getTotalQuantity() {
  const variants = getCurrentVariants();
  return variants.reduce((total, variant) => total + (variant.quantity || 0), 0);
}

function getTotalPrice() {
  const variants = getCurrentVariants();
  return variants.reduce((total, variant) => total + (variant.price * (variant.quantity || 0)), 0);
}

// Export functions for global access
window.getCurrentVariants = getCurrentVariants;
window.getVariantById = getVariantById;
window.getTotalQuantity = getTotalQuantity;
window.getTotalPrice = getTotalPrice;